import { Component, effect, input, Input, model, output } from '@angular/core';
import { PasswordValidations, PasswordValidationService } from '../services/password-validation.service';

@Component({
  selector: 're-password-requirements',
  standalone: false,
  templateUrl: './password-requirements.component.html',
  styleUrl: './password-requirements.component.scss',
})
export class PasswordRequirementsComponent {

  readonly password = input<string>();
  readonly username = input<string>();
  readonly firstName = input<string>();
  readonly lastName = input<string>();
  readonly domain = model<string>();
  readonly validateFirstAndLastName = input<boolean>(true);
  readonly validateUsername = input<boolean>(true);
  readonly validateDomain = input<boolean>(true);


  passwordValidations = new PasswordValidations();
  constructor(passwordValidationSvc: PasswordValidationService) {
    effect(() => {
      if (!this.domain() && this.username()) {
        var index = this.username().indexOf('@');
        if (index >= 0) {
          let dom = this.username().substr(index + 1);
          this.domain.set(dom);
        }
      }
      this.passwordValidations = passwordValidationSvc.validatePassword(this.password(), this.username(), this.domain(), this.firstName(), this.lastName(), this.validateFirstAndLastName(), this.validateUsername(), this.validateDomain());
      console.log(this.passwordValidations);
    });
  }

}
